import * as React from 'reactn';
import {ComponentFactory, dialog, IBaseDialogProps, SelectItem, StringUtil} from "oca-lib-web";
import Styles from "../style/Styles";

interface IState {
    componentFactory:ComponentFactory
}

class GraphOptionsDialog extends React.Component<IBaseDialogProps, IState> {

    constructor(props: any) {
        super();

        let componentFactory = new ComponentFactory(Styles.default);
        componentFactory.addDefaultBinding(null, null, props.param);

        this.state = {
            componentFactory:componentFactory
        };

        props.dialog.saveFunction(this.handleSave.bind(this));
    }

    componentWillMount() {
    }

    async handleSave(callback:any) {
        let componentBinding = this.state.componentFactory.getDefaultBinding();
        if (!componentBinding.getProperty("id")) {
            componentBinding.setProperty("id", StringUtil.uuid());
        }

        callback(componentBinding.item);
    }

    public render() {
        let graphWidthOptions = [
            SelectItem.create("half", "Half Page"),
            SelectItem.create("full", "Full Page")
        ];
        let graphColorOptions = [
            SelectItem.create("blue", "Blue"),
            SelectItem.create("violet", "Violet"),
            SelectItem.create("green", "Green"),
        ];
        let dataFormat = [
            SelectItem.create("number", "Number"),
            SelectItem.create("currency", "Currency"),
            SelectItem.create("time", "Time"),
        ]

        let cf = this.state.componentFactory;
        return (cf.renderBox([
            cf.renderBoxPadded(cf.renderSwitchField("showPercentIncrease", "Show Percent Increase")),
            cf.renderBoxPadded(cf.renderSwitchField("showStatistics", "Show Statistics")),
            cf.renderBoxPadded(cf.renderSwitchField("showDataLabels", "Show Data Labels")),
            cf.renderBoxPadded(cf.renderSwitchField("showLegend", "Show Legend")),
            cf.renderBoxPadded(cf.renderSwitchField("rotateXAxisLabel", "Rotate X Axis Label")),
            cf.renderBoxPadded(cf.renderSelectField("graphWidth", "Graph Width", graphWidthOptions)),
            cf.renderBoxPadded(cf.renderSelectField("graphColor", "Graph Color", graphColorOptions)),
            cf.renderBoxPadded(cf.renderSelectField("dataFormat", "Data Format", dataFormat)),
        ]));
    }
}

export default dialog(GraphOptionsDialog)